import Vue from "vue";
import {API_HOST} from "../settings/server";
import $store from "../store";
import axios from "axios";

class RegionService{
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getAll() {
        return Vue.axios.get(`${API_HOST}/api/region`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new RegionService()